import { useState } from "react";
import Web3 from 'web3';
import './App.css';

let myCHAIN = "XRPL EVM not found";
let buttonLABEL = " Connect Wallet ";
let connectedWALLET = "  ";
let myContract;
let web3;
let prefixAmount;
let mySupply = 1;

function App() {

    const contractAddress = '0x2bE025BFD429068Af25D49286cf1c7697E00F52A'
    const contractABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"tokenAddress","type":"address"}],"name":"TokenDeployed","type":"event"},{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_ticker","type":"string"},{"internalType":"uint256","name":"_supply","type":"uint256"}],"name":"deployToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"tokenCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokens","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"vault","outputs":[],"stateMutability":"payable","type":"function"}]

    const [numInput, setNumInput] = useState('0')
    const [nameInput, setNameInput] = useState('')
    const [symbolInput, setSymbolInput] = useState('')
    const [myMessage, setMyMessage] = useState('Enter numbers only for the total supply!')
    const [messageColor, setMessageColor] = useState('ff5555')
    const [myChainID, setMyChainID] = useState('Network not connected')

    async function mintTokens() {

        setMessageColor('ff5555')
        if (isNaN(numInput)) {
            setMyMessage('Enter numbers only for the total supply!')
        } else {
            if (numInput < 1) {
                setMyMessage('Your total supply must be greater than Zero (0)')
            } else {

                if (nameInput != '') {
                    if (symbolInput != '') {
                        if (web3) {
                            myContract = new web3.eth.Contract(contractABI, contractAddress)
                            if (myContract) {
                                setMessageColor('55ff55')
                                if (numInput == 1) {
                                    setMyMessage('Your Custom ERC20 Token is being created...')
                                } else {
                                    setMyMessage('Your Custom ERC20 Tokens are being created...')
                                }

                                try {
                                    await myContract.methods.deployToken(nameInput, symbolInput, mySupply).send({ from: connectedWALLET, value: prefixAmount, gas: 1000000});
                                    console.log("Transaction sent successfully!");
                                    setMyMessage("Transaction sent successfully!");
                                } catch (error) {
                                    console.error("Error writing to contract:", error);
                                    setMessageColor('FFA449');
                                    setMyMessage("Error writing to contract!");
                                }


                            } else {
                                setMyMessage('Your wallet needs to be set to the XRPL EVM. (1440000)')
                            }

                        } else {
                            setMyMessage('You must connect your wallet first.')
                        }

                    } else {
                        setMyMessage('The SYMBOL field cannot be null.')
                    }
                } else {
                    setMyMessage('The NAME field cannot be null.')
                }
            }
        }
    }

    function withPrefix() {
        prefixAmount = 100000000000000000;
        mySupply = (Number(numInput) * 1000000000000000000);
        mintTokens();
    }

    function withoutPrefix() {
        prefixAmount = 1000000000000000000;
        mySupply = (Number(numInput) * 1000000000000000000);
        mintTokens();
    }


    async function connectWallet() {
        if (window.ethereum) {
            myCHAIN='Connecting MetaMask...';
            try {
                // Request account access if needed
                await window.ethereum.request({ method: 'eth_requestAccounts' });

                // Initialize Web3 with the injected provider
                web3 = new Web3(window.ethereum);
                console.log('Connected to injected provider (e.g., MetaMask)');
                myCHAIN = 'Wallet Connected';

                // You can now interact with the blockchain using the web3 instance
                const accounts = await web3.eth.getAccounts();
                console.log('Accounts:', accounts);
                const chainId = await web3.eth.getChainId();
                console.log('Chain ID:', chainId);
                myCHAIN = chainId;
                connectedWALLET = accounts[0];
                if (myCHAIN == 1440000) {
                    buttonLABEL = " CONNECTED ";
                    setMyChainID(myCHAIN);
                }

            } catch (error) {
                console.error('User denied account access or an error occurred:', error);
                myCHAIN = 'Connection Failed';
            }
        } else {
            console.warn('No injected XRPL EVM provider found. Please install MetaMask or a similar wallet.');
            myCHAIN = 'No injected XRPL EVM provider found. Please install MetaMask or a similar wallet.';
        }
        setMyChainID(myCHAIN);
    }



  return (
    <div className="App">
          <header className="App-header">

              <br></br>

              <div id="custom_Display">

                  {myCHAIN}
                  <br></br>
                  {myCHAIN == 1440000 ? "XRPL EVM Sidechain" : "Wrong Network!"}

              </div>

              <input type="button" name="connect-button" value={buttonLABEL} onClick={connectWallet} className="App-button3" />


              <font size='3'>
                  {connectedWALLET}
              </font>

              <img src='logo192.png'  width='400' height='400' alt="Z-tokens" />
              <font color='55ff55'>
                ERC20 Token Factory 
              </font>
              <p></p>
              Token Name : <input type="text" name="t1" defaultValue=' ' className="App-text" onChange={e => setNameInput(e.target.value)} />
              <p></p>
              Ticker Symbol : <input type="text" name="t2" defaultValue=' ' className="App-text" onChange={e => setSymbolInput(e.target.value)} />
              <p></p>
              Total Supply : <input type="text" name="n1" defaultValue='0' className="App-text" onChange={e => setNumInput(e.target.value)} />
              <br></br>
              <font size='5' color={messageColor}>
                {myMessage}
              </font>
              <p></p>
              <input type="button" name="b1" value="MINT With Prefix" onClick={withPrefix} className="App-button1" />
              <p></p>
              <input type="button" name="b2" value="MINT Without Prefix" onClick={withoutPrefix} className="App-button2" />
              <p></p>
              <font size='3'>
                  Copyright 2025 Z-names
              </font>
              <p></p>
      </header>
    </div>
  );
}

export default App;
